import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { Align } from '@progress/kendo-angular-popup';
import { Alarme } from '../../../_models/Alarme';
import { ISousSysteme } from '../../../_models/SousSysteme';

@Component({
  selector: 'app-colored-circle-text',
  templateUrl: './colored-circle-text.component.html',
  styleUrls: ['./colored-circle-text.component.scss'],
})
export class ColoredCircleTextComponent implements OnInit {
  public show = false;
  public anchorAlign: Align = {
    horizontal: 'left',
    vertical: 'bottom',
  };

  @Input() bgColor = 'palegoldenrod';
  @Input() textColor = 'black';
  @Input() text = '';
  @Input() label = '';
  @Input() data!: Alarme[] | ISousSysteme;
  @Output() clicked = new EventEmitter<Alarme>();
  @Output() actionClicked = new EventEmitter<string>();

  @ViewChild('anchor') public anchor!: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup!: ElementRef;

  @HostListener('keydown', ['$event'])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  constructor() {}

  ngOnInit(): void {}

  public onClick(alarme: Alarme): void {
    this.clicked.emit(alarme);
    this.toggle(false);
  }

  public onActionClick(name: string): void {
    this.actionClicked.emit(name);
    this.toggle(false);
  }

  public toggle(show?: boolean): void {
    this.show = show !== undefined ? show : !this.show;
  }

  private contains(target: any): boolean {
    return (
      this.anchor.nativeElement.contains(target) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
